//
import React, { useState } from "react";

const HelpTabContent = () => {
  const [showAnswer, setShowAnswer] = useState<Record<string, boolean>>({});

  const toggleAnswer = (key: string) => {
    setShowAnswer((prevShow) => ({
      ...prevShow,
      [key]: !prevShow[key],
    }));
  };

  const sectionStyle = {
    // marginTop: '3rem',
    // backgroundColor: '#f5f5f7',
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    marginBottom: "2rem",
  };

  const buttonStyle = {
    backgroundColor: "#f5f5f7",
    color: "black",
    padding: "0.7rem 1rem",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "10px 0",
    display: "block",
    width: "100%",
    textAlign: "left" as "left",
    fontSize: "1rem",
  };

  const answerStyle = {
    padding: "0.7rem 1rem",
    color: "#333",
    // lineHeight: '1.6',
  };

  return (
    <div>
      <h2>Help</h2>
      <div style={{ marginTop: "3rem" }}>
        <h3>Contact Us</h3>
        <p>
          If you have any questions or need assistance, our team is ready to
          help. Feel free to chat with us on our website at{" "}
          <a
            href="https://www.motics.ai"
            target="_blank"
            style={{ textDecoration: "underline" }}
          >
            www.motics.ai
          </a>
          , or drop us an email at <strong>hello@motics.co.uk</strong>.
        </p>
      </div>

      <div style={{ marginTop: "3rem" }}>
        <h3>YouTube Walkthrough</h3>
        <p>
          We have compiled a YouTube playlist to guide you through our platform.
          We recommend watching our playlist to make the best out of our
          features. You can access our YouTube playlist{" "}
          <a
            href="https://www.youtube.com/playlist?list=PLxA5pksSkx2mTwZ1adDSyZXHCThqKszEv"
            target="_blank"
            style={{ textDecoration: "underline" }}
          >
            here
          </a>
          .
        </p>
      </div>

      <div style={{ marginTop: "3rem" }}>
        {/* <div style={sectionStyle}> */}
        <h3>Frequently Asked Questions</h3>

        <div style={sectionStyle}>
          <h3>First Session</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q1")}>
            How do I get started?
          </button>
          {showAnswer["q1"] && (
            <p style={answerStyle}>
              To get started with Motics Copilot, head to Start Session, select
              a note type, and press “Start Recording”.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q2")}>
            Why is it asking for permission to use the microphone?
          </button>
          {showAnswer["q2"] && (
            <p style={answerStyle}>
              We need your permission to access the microphone to capture the
              dialogue during your session to transcribe this, and generate your
              note.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q3")}>
            Which browser should I use?
          </button>
          {showAnswer["q3"] && (
            <p style={answerStyle}>
              Motics Copilot works in all browsers, but we suggest you use
              Google Chrome for the best experience.
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Legal/Consent, Data Privacy, Compliance</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q4")}>
            Is Motics Copilot GDPR compliant?
          </button>
          {showAnswer["q4"] && (
            <p style={answerStyle}>
              Yes, we follow all guidelines for GDPR compliance. We are awaiting
              our official 3rd party auditing to grant certification of
              compliance for GDPR.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q5")}>
            Will this technology affect my session?
          </button>
          {showAnswer["q5"] && (
            <p style={answerStyle}>
              No, Motics Copilot runs in the background. No inputs are needed
              during your session, allowing your healthcare professional to be
              focussed on you.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q6")}>
            Is my data safe and private?
          </button>
          {showAnswer["q6"] && (
            <p style={answerStyle}>
              Absolutely. Your privacy is paramount to how our platform works.
              All data is encrypted when being sent and stored. All audio
              recordings are deleted after 48 hours to further enhance
              protection.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q7")}>
            Is my data being used to train AI?
          </button>
          {showAnswer["q7"] && (
            <p style={answerStyle}>
              No. No audio recordings, patient information or other information
              held by Motics is used for training of new AI models or publicly
              shared. Information is only used to provide the service of
              generating clinical notes.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q8")}>
            Can I have my data deleted?
          </button>
          {showAnswer["q8"] && (
            <p style={answerStyle}>
              Yes, you can request for your data to be deleted at any time.
              Please liaise with Harvinder for this (harvinder@motics.co.uk).{" "}
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Microphone access</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q9")}>
            Do I need a special microphone?
          </button>
          {showAnswer["q9"] && (
            <p style={answerStyle}>
              No. We suggest starting with your computer’s inbuilt microphone
              (if present) as this is likely to provide a good starting point.
              You can purchase a “conferencing” microphone for better audio
              transcription if required. If your computer does not have a
              microphone, you will need to use an external microphone.
            </p>
          )}

          <button style={buttonStyle} onClick={() => toggleAnswer("q10")}>
            How can I see if my microphone access is not enabled?
          </button>
          {showAnswer["q10"] && (
            <p style={answerStyle}>
              If you click “Start Recording” and the button does not turn red,
              your microphone access is not enabled.{" "}
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Adding notes during a session</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q11")}>
            Can I add written notes during a session?
          </button>
          {showAnswer["q11"] && (
            <p style={answerStyle}>
              Yes. There is a textbox to add written content during the session
              which will be saved alongside your summary.
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Saving a session</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q12")}>
            How do I save a session?
          </button>
          {showAnswer["q12"] && (
            <p style={answerStyle}>
              Press “Stop Recording” and your session will be saved. Do not
              close the tab/window whilst your note is generating (you can
              switch tabs if needed).
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Note Errors</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q13")}>
            There’s an error in my notes - what can I do?
          </button>
          {showAnswer["q13"] && (
            <p style={answerStyle}>
              AI can sometimes make errors. We encourage you to check the
              transcript to ensure the content resembles your conversation and
              either attempt to regenerate your note with a custom instruction
              or edit manually. Feedback on errors is always appreciated and
              enables us to improve Copilot to provide a better experience.
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Regenerating notes/Converting between note types</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q14")}>
            How can I turn a SOAP note into another note type?
          </button>
          {showAnswer["q14"] && (
            <p style={answerStyle}>
              In the History Tab, click Regenerate and pick the note type you
              wish to convert to.{" "}
            </p>
          )}

          {/* <button style={buttonStyle} onClick={() => toggleAnswer("q15")}>
            What can Chat with AI do?
          </button>
          {showAnswer["q15"] && (
            <p style={answerStyle}>
              Chat with AI is an assistant which resembles how chatGPT performs.
              It is able to handle complex queries using your documents such as
              generating complex letters/bullet point notes, and create special
              custom formatting in a chat rather than regenerating.{" "}
            </p>
          )} */}
        </div>

        <div style={sectionStyle}>
          <h3>Tips and Tricks for Custom Templates</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q16")}>
            What should I put in my custom template?
          </button>
          {showAnswer["q16"] && (
            <p style={answerStyle}>
              We recommend having clear headings and a brief description of what
              to include in each section.
              <br />
              <br />
              For example:
              <br />
              Diagnosis (or multiple if present)
              <br />
              Past medical history (including previous operations/surgeries)
              <br />
              Subjective history (in bullet points with a single point per line)
              <br />
              Movement range of motion (include passive and active, list as
              angles)
              <br />
              Plan
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Cliniko Integration</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q17")}>
            How do I integrate with Cliniko?
          </button>
          {showAnswer["q17"] && (
            <p style={answerStyle}>
              Open your Account by clicking the icon in the top right with your
              initials. From there, go to Integrations. Here you will need to
              follow the instructions to find your Cliniko API key and paste it
              into the field.
            </p>
          )}
          <button style={buttonStyle} onClick={() => toggleAnswer("q18")}>
            How can I push my note to Cliniko?
          </button>
          {showAnswer["q18"] && (
            <p style={answerStyle}>
              In the History tab, you will be able to see a button which says
              “Assign to Patient”. Click this button and you will see a window
              appear with a dropdown to select your patient to assign to. This
              list is from your list of patients on Cliniko. Confirm that you
              want to save to your patient’s record and click Save. You should
              be able to see your note on your patient’s record.
            </p>
          )}
        </div>

        <div style={sectionStyle}>
          <h3>Generate Word Documents with Letterhead</h3>
          <button style={buttonStyle} onClick={() => toggleAnswer("q19")}>
            How do I upload my letterhead?
          </button>
          {showAnswer["q19"] && (
            <p style={answerStyle}>
              Open your Account by clicking the icon in the top right with your
              initials. From there, go to Settings, and Letter. Here, you can
              upload a word document with your letterhead (see the video
              demonstration{" "}
              <a href="https://www.youtube.com/watch?v=whmGpBAfHlE&list=PLxA5pksSkx2lQBxEz1Pulqj3QyjD4wgGk" target="_blank" rel="noopener noreferrer">
                here
              </a>{" "}
              for more information on how to format this correctly).
            </p>
          )}
          <button style={buttonStyle} onClick={() => toggleAnswer("q20")}>
            How do I generate a word document for a note/letter?
          </button>
          {showAnswer["q20"] && (
            <p style={answerStyle}>
              On your note, click Download as DOCX and this will use your
              letterhead (if uploaded), to generate a word document with the
              content of your note/letter.
            </p>
          )}
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default HelpTabContent;
